export const localStorageName = "goshweet_franchise"